import { FC } from 'react';
import { IconProps } from '../types';

export const BigGoldButtonSvg: FC<IconProps> = ({
  width = 300,
  height = 46,
  disabled,
  ...props
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 300 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="none"
      {...props}
    >
      <mask id="path-1-inside-1_12490_106643" fill="white">
        <path d="M295 0C295 2.76142 297.239 5 300 5V41C297.239 41 295 43.2386 295 46H5C5 43.2386 2.76142 41 0 41V5C2.76142 5 5 2.76142 5 0H295Z" />
      </mask>
      <path
        d="M295 0C295 2.76142 297.239 5 300 5V41C297.239 41 295 43.2386 295 46H5C5 43.2386 2.76142 41 0 41V5C2.76142 5 5 2.76142 5 0H295Z"
        fill="url(#paint0_linear_12490_106643)"
        fillOpacity={disabled ? 0.4 : 1}
      />
      <path
        d="M295 0H296.5V-1.5H295V0ZM300 5H301.5V3.5H300V5ZM300 41V42.5H301.5V41H300ZM295 46V47.5H296.5V46H295ZM5 46H3.5V47.5H5V46ZM0 41H-1.5V42.5H0V41ZM0 5V3.5H-1.5V5H0ZM5 0V-1.5H3.5V0H5ZM295 0H293.5C293.5 3.58985 296.41 6.5 300 6.5V5V3.5C298.067 3.5 296.5 1.933 296.5 0H295ZM300 5H298.5V41H300H301.5V5H300ZM300 41V39.5C296.41 39.5 293.5 42.4101 293.5 46H295H296.5C296.5 44.067 298.067 42.5 300 42.5V41ZM295 46V44.5H5V46V47.5H295V46ZM5 46H6.5C6.5 42.4101 3.58985 39.5 0 39.5V41V42.5C1.933 42.5 3.5 44.067 3.5 46H5ZM0 41H1.5V5H0H-1.5V41H0ZM0 5V6.5C3.58985 6.5 6.5 3.58985 6.5 0H5H3.5C3.5 1.933 1.933 3.5 0 3.5V5ZM5 0V1.5H295V0V-1.5H5V0Z"
        fill="url(#paint1_linear_12490_106643)"
        mask="url(#path-1-inside-1_12490_106643)"
        fillOpacity={disabled ? 0.2 : 1}
      />
      <defs>
        <linearGradient
          id="paint0_linear_12490_106643"
          x1="300"
          y1="2.04444"
          x2="277.556"
          y2="130.124"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D38B24" />
          <stop offset="0.0720001" stopColor="#DFB066" />
          <stop offset="0.152" stopColor="#EDDEA5" />
          <stop offset="0.242" stopColor="#F3C962" />
          <stop offset="0.347" stopColor="#FAD682" />
          <stop offset="0.485" stopColor="#FFE8B2" />
          <stop offset="0.652" stopColor="#D99D51" />
          <stop offset="0.802" stopColor="#D69C4D" />
          <stop offset="1" stopColor="#F0DFA7" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_12490_106643"
          x1="150"
          y1="46"
          x2="150"
          y2="5.63531e-07"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D38B24" />
          <stop offset="0.0720001" stopColor="#DFB066" />
          <stop offset="0.152" stopColor="#EDDEA5" />
          <stop offset="0.242" stopColor="#F3C962" />
          <stop offset="0.347" stopColor="#FAD682" />
          <stop offset="0.485" stopColor="#FFE8B2" />
          <stop offset="0.652" stopColor="#D99D51" />
          <stop offset="0.802" stopColor="#D69C4D" />
          <stop offset="1" stopColor="#F0DFA7" />
        </linearGradient>
      </defs>
    </svg>
  );
};
